import { render, staticRenderFns } from "./SalesOrganization.vue?vue&type=template&id=2663c7ea"
import script from "./SalesOrganization.vue?vue&type=script&lang=js"
export * from "./SalesOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports